import { Factory, RefreshCw, TrendingUp, Sigma, ShieldCheck, GraduationCap } from "lucide-react";
import { Reveal, Stagger, StaggerItem } from "../Reveal";

const ICONS = { factory: Factory, refresh: RefreshCw, trending: TrendingUp, sigma: Sigma, shield: ShieldCheck, graduation: GraduationCap };

export default function ProfileExpertise({ groups }) {
  if (!groups?.length) return null;
  return (
    <section id="expertises" className="bg-ink-900 text-paper grain relative py-24 md:py-32" data-testid="profile-expertise">
      <div className="relative z-10 mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal>
          <span className="label-mono text-gold">02 — Expertises</span>
          <h2 className="font-display text-4xl md:text-6xl font-semibold mt-4 tracking-tight max-w-4xl">Six domaines, une obsession : la performance.</h2>
        </Reveal>
        <Stagger className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 mt-14">
          {groups.map((g) => {
            const Icon = ICONS[g.icon] || Factory;
            return (
              <StaggerItem key={g.title}>
                <article className="group h-full rounded-sm border border-paper/10 bg-ink-950/60 p-7 hover:border-gold/50 hover:-translate-y-1 transition-all duration-500" data-testid={`expertise-${g.icon}`}>
                  <div className="w-11 h-11 rounded-full border border-gold/40 text-gold flex items-center justify-center group-hover:bg-gold group-hover:text-ink transition-colors duration-500">
                    <Icon size={19} />
                  </div>
                  <h3 className="font-display text-2xl font-semibold mt-5">{g.title}</h3>
                  <ul className="mt-5 space-y-2">
                    {(g.items || []).map((it) => (
                      <li key={it} className="flex items-start gap-2.5 text-paper/60 text-sm">
                        <span className="mt-[7px] w-1.5 h-1.5 rounded-full bg-gold/70 shrink-0" />{it}
                      </li>
                    ))}
                  </ul>
                </article>
              </StaggerItem>
            );
          })}
        </Stagger>
      </div>
    </section>
  );
}
